import { LootboxInventory } from '@/components/templates/Lootbox/templates/LootboxInventory'
import { memo } from 'react'
import Layout from './layout'

const Inventory = () => {
  return (
    <Layout>
      <LootboxInventory />
    </Layout>
  )
}

export default memo(Inventory)
